import { render, staticRenderFns } from "./data-presentation-pages.vue?vue&type=template&id=7a7f1dea"
import script from "./data-presentation-pages.vue?vue&type=script&lang=js"
export * from "./data-presentation-pages.vue?vue&type=script&lang=js"
import style0 from "./data-presentation-pages.vue?vue&type=style&index=0&id=7a7f1dea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports